/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";

// Data

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { useState } from "react";
import { baseURL } from "utils/api";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import useSWR from "swr";
import axios from "axios";
import LoaderComponent from "components/Loader";
function CustomerList() {
  const navigate = useNavigate();

  

  const [allIds, setAllIds] = useState([]);

  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
  const { data, error } = useSWR(`${process.env.REACT_APP_BASE_URL}/users/getAllUsers`, fetchData, {
    refreshInterval: 1000
  });
  console.log(data, "data");

  const user_img = 'https://images.unsplash.com/flagged/photo-1573740144655-bbb6e88fb18a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8dXNlcnxlbnwwfHwwfHx8MA%3D%3D';


  //  delete a single user by id

  const handleDeleteuser = async (id) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/delete/user/${id}`);
      if (res.status === 200) {

      }
    } catch (error) {
      console.log(error);

    }
  }

  // selection handler to delete multiple users by id
  // this function is passed as prop to mui data grid to get ids paramater
  const onRowsSelectionHandler = (ids) => {

    const selectedRowsData = ids.map((id) => rows.find((row) => row?._id === id));
    console.log(selectedRowsData)
    const foundIds = selectedRowsData.map((d) => d?._id);
    setAllIds(foundIds);
  };
  console.log(allIds)

  // function to delete multiple selected users-:
  const handleDeleteSelectedRows = async () => {
    let result = confirm("Are you sure you want to delete?");
    if (!result) {
      return;
    }
    try {
      // setFormLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/delete/multiple/users`, {
        ids: allIds
      });

      // setFormLoading(false);
    } catch (error) {
 
      // setFormLoading(false);
    }
  }

  // columns to render in mui data grid
  const columns = [
    { field: "_id", headerName: " USER ID", width: 120 },
   
    {
      field: "phone",
      headerName: "Mobile",
      width: 120,

    },
    {
      field: "referralCode",
      headerName: "Refferal Code",
      width: 120,
      editable: true,
    },
    {
      field: "referredBy",
      headerName: "Reffered By ID",
      width: 120,
      editable: true,
    },
    {
      field: "email",
      headerName: "Email",


      width: 100,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    // {
    //   field: "age",
    //   headerName: "Age",


    //   width: 100,
    //   // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    // },
    {
      field: "gender",
      headerName: "Gender",


      width: 100, 
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },

    {
      field: "role",
      headerName: "Role",


      width: 100,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      description: "Not Sortable dates",
      sortable: false,
      width: 130,
      // valueGetter: (params) => `${params?.row?.createdAt?.toISOString().split('T')[0]}`,
    },
    {
      field: "updatedAt",
      headerName: "Updated Date",
      description: "Not Sortable dates",
      sortable: false,
      width: 130,
      // valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 180,
      renderCell: (param) => {
        const detailsObj = { ...param.row };
        const fieldsToIgnore = ['history', 'transactions', 'rewardPoints'];
        fieldsToIgnore.forEach(field => delete detailsObj[field]);
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip onClick={() => navigate("/view_details", { state: detailsObj })} title="view">
                <IconButton>
                  <MdOutlinePreview style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip onClick={() => navigate("/edit_user", { state: param.row._id })} title="Edit">
                <IconButton>
                  <FaEdit className="text-blue-400" style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip onClick={() => handleDeleteuser(param.row._id)} title="Delete">
                <IconButton>
                  <MdDelete className="text-red-400" style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
            </div>
          </>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];
  console.log(data,'OOOOPPP');
  const rows = data ? data?.data : [];




  return (
    <DashboardLayout>
      {
        !data && <LoaderComponent open={true} />
      }
      <DashboardNavbar />
      <MDBox py={3}>
        <div className="flex flex-col items-start justify-start gap-4" style={{marginLeft:"92%"}}>
          <label >
            <span onClick={() => navigate("/add_new_user")} type="button" className="p-2 h-[5vh] cursor-pointer rounded-md w-[8vw] text-sm text-white border-none outline-none bg-blue-700">Add User</span>
          </label>
          {
            allIds.length > 0 && <label className="mt-4"> <span onClick={handleDeleteSelectedRows} type="button" className="bg-red-700 h-[5vh]  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none  text-white">Delete Selected</span>
            </label>
          }
        </div>

        <Box sx={{ height: 548, width: "100%", background: "white", marginTop:"1%" }}>
          {console.log(rows,'rowssss')}
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            getRowId={(row) => row?._id}
            pageSizeOptions={[5, 10, 100]}
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CustomerList;
